export enum SocketNotificationMessageType {
  COUNTER_LIKE = 'likeCounter',
  COUNTER_VISIT = 'visitCounter',
  COUNTER_MESSAGE = 'messageCounter',
  EVENT_NEW_MESSAGE = 'newMessageReceived',
}

export interface ISocketDetailsCounter {
  counterValue: number;
}

export interface ISocketDetailsNewMessage {
  sender: {
    id: number;
  };
  message: {
    id: string;
    thread_id: string;
    content: string;
    partial_content: boolean;
    type: string;
  };
}

export interface ISocketMessage {
  notificationType: SocketNotificationMessageType;
  submissionDate: string;
  source: string;
  details: ISocketDetailsCounter | ISocketDetailsNewMessage;
}

export enum SocketNotificationEventType {
  NEW_MESSAGE_RECEIVED = 'new_message_received',
}

export interface ISocketNotificationEvent {
  message: {
    id: string;
    partial_content: boolean;
    content: string;
    thread_id: string;
    type: string;
  };
  sender_id: string;
  date: string;
  source: string;
  type: SocketNotificationEventType;
}

export interface ISocketNotificationCounter {
  type: SocketNotificationCounterType;
  value: number;
}

export enum SocketNotificationCounterType {
  FAVORITE = 'MEMO',
  MESSAGE = 'MAIL',
  VISIT = 'VIS',
}

export enum SocketNotificationType {
  COUNTER = 'counter',
  EVENT = 'event',
}

export type SocketNotificationContent =
  | { [SocketNotificationType.COUNTER]: ISocketNotificationCounter }
  | { [SocketNotificationType.EVENT]: ISocketNotificationEvent };
